export const DurationFormat = {
  DHM: ['days', 'hours', 'minutes'],
  DHMS: ['days', 'hours', 'minutes', 'seconds'],
};
